import withReactContent from "sweetalert2-react-content"
import Swal from "sweetalert2"

export const confirmAlert = async (title, msg, confirmBtnText = 'Yes') => {
    const sweetAlert = withReactContent(Swal)
    const result = await sweetAlert.fire({
        title,
        icon: 'warning',
        html: msg,
        confirmButtonText: confirmBtnText,
        allowOutsideClick: false,
        showCancelButton: true
    })
    return result.isConfirmed
}

export const successAlert = (msg, isConfirmButton = true) => {
    const sweetAlert = withReactContent(Swal)
    sweetAlert.fire({
        title: 'Congratulations',
        icon: 'success',
        html: msg,
        showConfirmButton: isConfirmButton,
        allowOutsideClick: !isConfirmButton,
        ...(isConfirmButton ? {} : { timer: 3000, timerProgressBar: true })
    }).then(r => r)
}

export const errorAlert = (msg) => {
    const sweetAlert = withReactContent(Swal)
    sweetAlert.fire({
        title: 'Please Fix!',
        icon: 'error',
        html: msg,
        allowOutsideClick: false
    }).then(r => r)
}

export const warningAlert = (msg, isConfirmButton = true) => {
    const sweetAlert = withReactContent(Swal)
    sweetAlert.fire({
        title: 'Heads Up!',
        icon: 'warning',
        html: msg,
        showConfirmButton: isConfirmButton,
        allowOutsideClick: !isConfirmButton,
        ...(isConfirmButton ? {} : { timer: 4000, timerProgressBar: true })
    }).then(r => r)
}